/**
 * After a new deploy, cached HTML / entry JS may still point at old hashed chunks.
 * Dynamic import() then throws; React Router shows "Failed to fetch dynamically imported module".
 * One hard reload usually fixes it. This registers a one-shot recovery attempt per tab session.
 */
const SESSION_KEY = "oaStudentWeb_chunk_reload_once";

function messageFromReason(reason: unknown): string {
  if (reason instanceof Error) return reason.message;
  if (typeof reason === "string") return reason;
  try {
    return String(reason);
  } catch {
    return "";
  }
}

function isLikelyStaleChunkError(message: string): boolean {
  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /ChunkLoadError/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

export function registerChunkLoadRecovery(): void {
  if (typeof window === "undefined") return;

  const maybeReload = (reason: unknown): boolean => {
    const message = messageFromReason(reason);
    if (!isLikelyStaleChunkError(message)) return false;

    try {
      if (sessionStorage.getItem(SESSION_KEY)) return false;
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
      return false;
    }

    window.location.reload();
    return true;
  };

  window.addEventListener("unhandledrejection", (event) => {
    if (maybeReload(event.reason)) {
      event.preventDefault();
    }
  });

  window.addEventListener("error", (event) => {
    if (event.error && maybeReload(event.error)) {
      event.preventDefault();
    }
  });
}
